//	ref: https://stackoverflow.com/a/40724354/6637365
const mySymbol = ['', 'k', 'M', 'B', 'T', 'P', 'E']

const shortNumber = (number) => {
	// what tier? (determines SI symbol)
	const tier = Math.log10(number) / 3 | 0 //	eslint-disable-line no-bitwise

	// if zero, we don't need a suffix
	if (tier === 0) return number

	// get suffix and determine scale
	const suffix = mySymbol[tier]
	const scale = 10 ** (tier * 3)

	// scale the number
	const scaled = number / scale

	// format number and add suffix
	return scaled.toFixed(1) + suffix
}

export default shortNumber



// WEBPACK FOOTER //
// ./src/utilities/shortNumber.js